import React from 'react';
import './search.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn } from "mdbreact";
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter,Redirect} from 'react-router-dom'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import {setUser} from '../../redux/actions/AuthActions'
import {Input,Checkbox} from 'antd';
import LoadCard from '../../component/load card/load card'
import { SearchOutlined  } from '@ant-design/icons';

class Search extends React.Component {
  
  state = {
    users:[],
    offices:[],
    ads:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    showoffices:true,
    showads:true,
    showusers:true,
    value:this.props.history.location.state?this.props.history.location.state.data:'',
    checkedValues:["offices","users","ads"]
  }
  constructor(props){
    super(props)
    console.log("isr   ",this.props.history)
    this.getuserWithoutPagenation()
    this.getofficesWithoutPagenation()
    this.getads()
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    window.scrollTo(0,0)
  }
  getofficesWithoutPagenation = () => {
    this.setState({loading:true})
    let value = this.state.value
    console.log(value)
    let url =``;
    if(value !== ''){
        url = `${BASE_END_POINT}find?type=OFFICE&search=${value}`
    }else{
      url = `${BASE_END_POINT}find?type=OFFICE`
    }
    
    axios.get(url)
    .then(response=>{
      console.log(response.data.data)
      this.setState({offices:response.data.data,loading:false})
    })
    .catch(error=>{
      this.setState({loading:false})
      console.log("ALL ads ERROR")
      console.log(error.response)
    })
  }
  getuserWithoutPagenation = () => {
    this.setState({loading:true})
    let value = this.state.value
    let url =``;
    if(value !== ''){
        url = `${BASE_END_POINT}find?type=USER&search=${value}`
    }else{
      url = `${BASE_END_POINT}find?type=USER`
    }
    axios.get(url)
    .then(response=>{
      console.log(response.data.data)
      this.setState({users:response.data.data,loading:false})
    })
    .catch(error=>{
      console.log("ALL ads ERROR")
      console.log(error.response)
    })
  }
  getads = () => {
    this.setState({loading:true})
    let value = this.state.value
    let url =``;
    if(value !== ''){
        url = `${BASE_END_POINT}ads?search=${value}`
    }else{
      url = `${BASE_END_POINT}ads`
    }
    axios.get(url,{headers: {
      'Content-Type': 'application/json',
      'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      },})
    .then(response=>{
      console.log(response.data.data)
      this.setState({ads:response.data.data,loading:false})
    })
    .catch(error=>{
      console.log("ALL ads ERROR")
      console.log(error.response)
    })
  }
  onChange = (checkedValues) => {
    console.log('checked = ', checkedValues);
    let offices = checkedValues.indexOf("offices");
    let users = checkedValues.indexOf("users");
    let ads = checkedValues.indexOf("ads");
    console.log(ads)
    if(offices !== -1){
      this.setState({showoffices:true})
    }else{
      this.setState({showoffices:false})
    }
    if(users !== -1){
      this.setState({showusers:true})
    }else{
      this.setState({showusers:false})
    }
    if(ads !== -1){
      this.setState({showads:true})
    }else{
      this.setState({showads:false})
    }
  }
 
  render(){
    if (this.props.currentUser.user.type !== "ADMIN") return <Redirect to='/Home' /> 
  return (
    <div className="Category search">
      <div className="filters" style={{marginBottom: "2rem"}}>
        <MDBContainer> 
          <MDBRow>
            <MDBCol xl="4" lg="4" md="4" sm="12">
              <MDBBtn  
              onClick={() => {
                this.getuserWithoutPagenation()
                this.getads()
                this.getofficesWithoutPagenation()
                document.getElementById('theSearch').value = "";
              }} 
                style={{width:'150px',padding:'9px',height:'40px',float:'right',margin:0 }}
                    className="btn z-depth-1a "
                    color="primary"
                >
                  {allStrings.Search}
              </MDBBtn>
            </MDBCol>
            <MDBCol xl="8" lg="8" md="8" sm="12">
              <Input 
              id="theSearch"
                onKeyUp={(e)=>{
                      console.log("ENTER   ",e.target.value)
                      this.setState({value:e.target.value})
                }} 
                placeholder={allStrings.Search}
                size="large"  prefix={<SearchOutlined placeholder="أدخل البيانات..." />} />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <Checkbox.Group defaultValue={this.state.checkedValues}
         style={{ width: '100%',textAlign: 'end',padding: '10px 30px' }}  onChange={this.onChange}>
          <Checkbox value="offices">{allStrings.offices}</Checkbox>
          <Checkbox value="ads">{allStrings.ads}</Checkbox>
          <Checkbox value="users">{allStrings.users}</Checkbox>
        </Checkbox.Group>
      </div>
      <MDBContainer> 
        {this.state.showoffices === true &&
        <MDBRow>
          <MDBCol md="12">
            <label  htmlhtmlFor="defaultFormRegisterNameEx2"
            style={{
              float:'right',
              color: 'slategray',
              fontSize: '18px',
              marginBottom: '20px',
              marginTop: '20px'
            }}>
            {allStrings.offices}
            </label>
          </MDBCol>
        </MDBRow>
        }
        {this.state.showoffices === true &&
        <div className="searchCountainer">
          <MDBRow>
            {this.state.loading?
              <LoadCard/>
              :
              this.state.offices.length > 0 ?
                this.state.offices.map(OFFICE=>(
                  <MDBCol xl="4" lg="6" md="12" sm="12">
                  <div className="categoryCard">
                  <MDBContainer> 
                    <MDBRow>
                      <MDBCol xl="2" lg="2" md="2" sm="2">
                      </MDBCol>
                      <MDBCol xl="6" lg="6" md="6" sm="6" className="noPadding">
                        <div className="categoryInfo" onClick={() => this.props.history.push('/userInfo',{data:OFFICE})}>
                          <p style={{
                            fontWeight: '600',
                            color:'#1D9598',
                            marginBottom: '6px',
                            fontSize: '1.2rem'
      
                          }}>{OFFICE.fullname?".. " +OFFICE.fullname.substr(0,10):"" }</p>
                          <p style={{
                          color: '#A4A3B0',
                          fontSize: '14px',
                          marginBottom: '8px'}}>{OFFICE.phone}</p>
                         
                        </div>
                      </MDBCol>
                      <MDBCol xl="4" lg="4" md="4" sm="4">
                        <div className="categoryImg" >
                          <img alt="" style={{width: '75px',
                          height: '75px',marginBottom:'10px',
                          borderRadius: '100%'}} src={OFFICE.img?OFFICE.img:require('../../assets/images/profileicon.jpg')}></img>
                        </div>
                      </MDBCol>
                    </MDBRow>
                  </MDBContainer> 
                  </div>
                  </MDBCol>
                ))
                :
                <div className="noData">{allStrings.noData}</div>
            }
            </MDBRow>
        </div>
      }{this.state.showusers === true &&
        <MDBRow>
          <MDBCol md="12">
            <label  htmlhtmlFor="defaultFormRegisterNameEx2"
            style={{
              float:'right',
              color: 'slategray',
              fontSize: '18px',
              marginBottom: '20px',
              marginTop: '20px'
            }}>
            {allStrings.users}
            </label>
          </MDBCol>
        </MDBRow>
       }{this.state.showusers === true &&
        <div className="searchCountainer">
          <MDBRow>
          {this.state.loading?
            <LoadCard/>
            :
            this.state.users.length > 0 ?
              this.state.users.map(user=>(
                <MDBCol xl="4" lg="6" md="12" sm="12">
                <div className="categoryCard" >
                <MDBContainer> 
                  <MDBRow>
                    <MDBCol xl="2" lg="2" md="2" sm="2">
                    </MDBCol>
                    <MDBCol xl="6" lg="6" md="6" sm="6" className="noPadding">
                      <div className="categoryInfo" onClick={() => this.props.history.push('/userInfo',{data:user})} >
                        <p style={{
                          fontWeight: '600',
                          color:'#1D9598',
                          marginBottom: '6px',
                          fontSize: '1.2rem'
    
                        }}>{user.fullname?".. " +user.fullname.substr(0,10):""}</p>
                      
                        <p style={{
                        color: '#1D9598',
                        fontSize: '16px',
                        marginBottom: '8px',
                        display:'inline-block'}}>{user.phone} </p>
                      </div>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="4">
                      <div className="categoryImg" >
                        <img alt="" style={{width: '75px',
                        height: '75px',marginBottom:'10px',
                        borderRadius: '100%'}} src={user.img?user.img:require('../../assets/images/profileicon.jpg')}></img>
                      </div>
                    </MDBCol>
                  </MDBRow>
                
                </MDBContainer> 
                </div>
                </MDBCol>
              ))
              :
              <div className="noData">{allStrings.noData}</div>
          }
          </MDBRow>
        </div>
        }{this.state.showads === true &&
        <MDBRow>
          <MDBCol md="12">
            <label  htmlhtmlFor="defaultFormRegisterNameEx2"
            style={{
              float:'right',
              color: 'slategray',
              fontSize: '18px',
              marginBottom: '20px',
              marginTop: '20px'
            }}>
            {allStrings.ads}
            </label>
          </MDBCol>
        </MDBRow>
        }{this.state.showads === true &&
        <div className="searchCountainer">
          <MDBRow>
          {this.state.loading?
            <LoadCard/>
            :
            this.state.ads.length > 0 ?
              this.state.ads.map(theAd=>(
                <MDBCol xl="4" lg="6" md="12" sm="12">
                <div className="categoryCard" >
                <MDBContainer> 
                  <MDBRow>
                    <MDBCol xl="2" lg="2" md="2" sm="2">
                    </MDBCol>
                    <MDBCol xl="6" lg="6" md="6" sm="6" className="noPadding">
                      <div className="categoryInfo" onClick={() => this.props.history.push('/AdsInfo',{data:theAd})} >
                        <p style={{
                          fontWeight: '600',
                          color:'#1D9598',
                          marginBottom: '6px',
                          fontSize: '1.2rem'
    
                        }}>{this.props.isRTL?".. " +theAd.title.substr(0,15):".." +theAd.title.substr(0,15)}</p>
                      
                        <p style={{
                        color: '#1D9598',
                        fontSize: '16px',
                        margin: 0,
                        marginBottom: '10px'}}>{theAd.category?this.props.isRTL?theAd.category.categoryName_ar:theAd.category.categoryName_en :""}</p>
                        
                      </div>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="4">
                      <div className="categoryImg" >
                        <img alt="" style={{width: '75px',
                        height: '75px',marginBottom:'10px',
                        borderRadius: '100%'}} src={theAd.imgs[0]?theAd.imgs[0]:require('../../assets/images/profileicon.jpg')}></img>
                      </div>
                    </MDBCol>
                  </MDBRow>
                
                </MDBContainer> 
                </div>
                </MDBCol>
              ))
              :
              <div className="noData">{allStrings.noData}</div>
          }
          </MDBRow>
        </div>
      }
      </MDBContainer> 
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  setUser,
  ChangeLanguage,
}

export default  withRouter( connect(mapToStateProps,mapDispatchToProps) (Search))
